// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../types';

import gql from 'graphql-tag';
import { SuppliersSupplierDealFragmentDoc } from '../../../../Components/Suppliers/Suppliers.generated-types';
import { ProposalModalEventFragmentDoc, ProposalModalProposalFragmentDoc } from '../../ProposalModal/ProposalModal.generated-types';
import { UseDateTimeDurationEventFragmentDoc } from '../../../../Hooks/useDateTimeDuration/useDateTimeDuration.generated-types';
import { AttachmentsProposalFragmentDoc } from './Attachments/Attachments.generated-types';
import { GetAddressProposalFragmentDoc } from '../../../../Graphql-Utilities/getAddress/getAddress.generated-types';
export type ConfirmedBookingEventFragment = { __typename?: 'Event', UUID: string, name: string, currency: string, fromDateTime: string, toDateTime: string, layoutID: string, proposals: Array<{ __typename?: 'Proposal', UUID: string, baseCostTotal: number, ID: number, currency: string, baseCostDescription: string, message?: string | null, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, description?: string | null, tour3dUrl?: string | null, spacePhotos?: Array<{ __typename?: 'SelfServeSpacePhoto', url?: string | null }> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, addressLine1?: string | null, city?: string | null, postalCode?: string | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null } | null } | null, spaceFeatures?: Array<{ __typename?: 'SelfServeSpaceFeature', ID?: number | null, name?: string | null }> | null, spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null }, documents?: Array<{ __typename?: 'ProposalDocument', filename: string, URL: string, ID: number }> | null, extraCostItems?: Array<{ __typename?: 'ExtraCostItem', ID: number, description: string, quantity?: number | null, costPerUnit: number }> | null }>, supplierDeals?: Array<{ __typename?: 'SupplierDeal', ID: number, message?: string | null, cost?: number | null, supplier: { __typename?: 'Supplier', ID: number, name: string, type: Types.SupplierType }, attachments?: Array<{ __typename?: 'SupplierDealAttachment', ID: number, filename: string, URL: string }> | null }> | null };

export type ConfirmedBookingProposalFragment = { __typename?: 'Proposal', UUID: string, baseCostTotal: number, ID: number, currency: string, baseCostDescription: string, message?: string | null, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, description?: string | null, tour3dUrl?: string | null, spacePhotos?: Array<{ __typename?: 'SelfServeSpacePhoto', url?: string | null }> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, addressLine1?: string | null, city?: string | null, postalCode?: string | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null } | null } | null, spaceFeatures?: Array<{ __typename?: 'SelfServeSpaceFeature', ID?: number | null, name?: string | null }> | null, spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null }, documents?: Array<{ __typename?: 'ProposalDocument', filename: string, URL: string, ID: number }> | null, extraCostItems?: Array<{ __typename?: 'ExtraCostItem', ID: number, description: string, quantity?: number | null, costPerUnit: number }> | null };

export const ConfirmedBookingProposalFragmentDoc = gql`
    fragment ConfirmedBookingProposal on Proposal {
  UUID
  baseCostTotal
  space {
    spaceName
    spacePhotos {
      url
    }
    venue {
      name
    }
  }
  ...AttachmentsProposal
  ...GetAddressProposal
  ...ProposalModalProposal
}
    ${AttachmentsProposalFragmentDoc}
${GetAddressProposalFragmentDoc}
${ProposalModalProposalFragmentDoc}`;
export const ConfirmedBookingEventFragmentDoc = gql`
    fragment ConfirmedBookingEvent on Event {
  UUID
  name
  currency
  fromDateTime
  toDateTime
  proposals {
    ...ConfirmedBookingProposal
  }
  supplierDeals {
    ...SuppliersSupplierDeal
  }
  ...ProposalModalEvent
  ...UseDateTimeDurationEvent
}
    ${ConfirmedBookingProposalFragmentDoc}
${SuppliersSupplierDealFragmentDoc}
${ProposalModalEventFragmentDoc}
${UseDateTimeDurationEventFragmentDoc}`;